import { AttachmentsZone, FormTab } from '@kirz/mui-admin';
import React, { useContext } from 'react';

import { SettingsContext } from 'contexts/SettingsContext';

export default function FilesTab(props: { estateId: number }) {
  const { estateId } = props;
  const { attachmentTypes } = useContext(SettingsContext);

  console.log(attachmentTypes);
  return (
    <FormTab tab="files">
      <AttachmentsZone
        name="estateId"
        entityId={estateId}
        title="Файлы"
        attachmentsTypes={attachmentTypes.estate}
      />
    </FormTab>
  );
}
